import React from "react";

import icon from "./icon.png";
import { Props } from "./types";

function TransferIcon({ className }: Props) {
  return (
    <img
      className={className}
      style={{ width: "initial" }}
      src={icon}
      alt="Transfer zones"
    />
  );
}

export { TransferIcon };
